import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Dialog, DialogContent, DialogActions, Grid } from "@mui/material";
import { ReadTextField } from "@icoach/components/";
import { Button, Card } from "@curves/ui-base";
import Tablenization from "@icoach/components/Tablenization";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { useMemberOrderApi } from "@apis/useMemberOrderApi";
import { isEmpty, isFunction } from "@util/utils";
import { PAYMENT_SOURCE_TYPE_MAP } from "@icoach/constants";

const headerRow = [
	{
		cellKey: "orderNo",
		headerLabel: "訂單號碼",
	},
	{
		cellKey: "items",
		headerLabel: "費用項目",
		formatCell: items => {
			return items[0]?.productName ?? null;
		},
	},
	{
		cellKey: "payablePrice",
		headerLabel: "應繳金額",
		align: "right",
	},
];

const SmartFitnessBandOverdueDialog = React.forwardRef((props, ref) => {
	const { sourceData: sourceDataProps, open: openProps = false, onClose: onCloseProps, refresh } = props;
	if (!openProps) return null;
	const { memberID, memberName, memberNo, dialogRef } = sourceDataProps || {};
	const { getMemberOverduePaymentApi, postMemberDeviceOrderPackingBatch } = useMemberOrderApi();
	const [sourceData, setSourceData] = useState(null);
	const { orders = [] } = sourceData || {};

	const handleChangeCreditCard = () => {
		const { openSmartFitnessBandEditCreditCardDialog } = dialogRef.current;
		isFunction(openSmartFitnessBandEditCreditCardDialog) &&
			openSmartFitnessBandEditCreditCardDialog({
				memberID,
				memberName,
				memberNo,
				memberPaymentID: sourceData.memberPaymentID,
				sourceType: PAYMENT_SOURCE_TYPE_MAP.DEVICEORDER,
			});
	};

	const handleClickRetryDebit = async () => {
		const resp = await postMemberDeviceOrderPackingBatch(memberID);

		if (resp) {
			isFunction(refresh) && refresh();
			isFunction(onCloseProps) && onCloseProps();
		}
	};

	const getOverduePaymentDataApi = async memberID => {
		const resp = await getMemberOverduePaymentApi(memberID);
		setSourceData(resp);
	};

	useEffect(
		() => {
			if (memberID) getOverduePaymentDataApi(memberID);
		},
		// eslint-disable-next-line
		[memberID]
	);

	return (
		<Dialog className={clsx("simple-content", "dialog")} PaperProps={{ className: "wx-90rem" }} open={openProps} fullWidth>
			<GradientColorHeader onClose={onCloseProps}>智能欠費明細</GradientColorHeader>
			<DialogContent>
				{!isEmpty(orders[0]) && (
					<React.Fragment>
						<Card className="order-info-card mb-4">
							<Card.CardContent className="p-4">
								<Grid container spacing={2}>
									<Grid item xs={6}>
										<ReadTextField label="會員姓名" direction="row">
											{memberName}
										</ReadTextField>
									</Grid>
									<Grid item xs={6}>
										<ReadTextField label="會員編號" direction="row">
											{memberNo}
										</ReadTextField>
									</Grid>
								</Grid>
							</Card.CardContent>
						</Card>
						<Tablenization cardProps={{ className: "theme-gray overview" }}>
							<Tablenization.TableRowHeader headerRow={headerRow} />
							<Tablenization.TableRowBody key={orders.length} headerRow={headerRow} rowsData={orders} />
						</Tablenization>
					</React.Fragment>
				)}
			</DialogContent>
			<DialogActions>
				<Button variant="contained" onClick={handleChangeCreditCard}>
					變更信用卡
				</Button>
				<Button variant="contained" onClick={handleClickRetryDebit}>
					再次扣款
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default SmartFitnessBandOverdueDialog;
